import React from 'react';
import { connect } from 'react-redux';

import { createComponent, Layout, Header, Button, Label, enums, PropTypes } from 'console-kit';
import authStatics from '../../../common/static';

import SsoLogoutPanelActions from '../redux/actions';
import AuthImageLogo from '../../../components/AuthImageLogo';

const SsoLogoutPanel = createComponent({
  displayName: 'SsoLogoutPanel',
  propTypes:   {
    loginLink: PropTypes.string,
  },
  defaultProps: {
    loginLink: undefined,
  },
  handlers: {
    handleClick: p => (e, { value }) => {
      window.location.href = p.loginLink;
      p.onRedirectRequestClicked();
    },
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Logged out"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text="You have been logged out of the platform."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <If condition={props.loginLink}>
            <Layout.Row>
              <Button.WithAnimation
                actions={{
                  start:   SsoLogoutPanelActions.onRedirectRequest,
                  success: SsoLogoutPanelActions.onRedirectSuccess, //no action
                  failure: SsoLogoutPanelActions.onRedirectFailure, //no action
                }}
              >
                <Button.Primary
                  text="Login"
                  float={enums.positions.RIGHT}
                  size={enums.sizes.X4}
                  onClick={props.handleClick}
                  textAlign={enums.textAlignments.CENTER}
                  color={enums.colors.ACCENT}
                  isSolid
                  isFluid
                  isDisabled={false}
                />
              </Button.WithAnimation>
            </Layout.Row>
          </If>
        </Layout>
      </div>
    );
  },
});

export default connect(null, dispatch => ({
  onRedirectRequestClicked() {
    dispatch(SsoLogoutPanelActions.onRedirectRequest());
  },
}))(SsoLogoutPanel);
